var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "co2calc ce_form" }, [
    _c("div", { class: ["co2calc__topbar", { sticky: _vm.isSticky }] }, [
      _c("span", [
        _vm._v(
          _vm._s(Math.round(_vm.pathStyleEnergyConsumption.percentage)) + "%"
        ),
        _c("small", [_vm._v(_vm._s(_vm.lang.savings))])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "hide-mobile" }, [
        _vm._v(
          _vm._s(_vm.formatNumber(_vm.energyConsumptionDifference)) + " kWh "
        ),
        _c("small", [_vm._v(_vm._s(_vm.lang.savings))])
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "hide-mobile" }, [
        _vm._v(_vm._s(_vm.formatNumber(_vm.energyCostDifference)) + " CHF "),
        _c("small", [_vm._v(_vm._s(_vm.lang.savings))])
      ]),
      _vm._v(" "),
      _c("span", [
        _vm._v(_vm._s(_vm.formatNumber(_vm.co2EmissionsDifference)) + " kg "),
        _c("small", [
          _vm._v("CO"),
          _c("sub", [_vm._v("2")]),
          _vm._v(" " + _vm._s(_vm.lang.savings))
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.currentStep >= 3
      ? _c(
          "section",
          { staticClass: "co2calc__section co2calc__section--result" },
          [
            _c("h2", { staticClass: "co2calc__section-title" }, [
              _vm._v(_vm._s(_vm.lang.maintitle))
            ]),
            _vm._v(" "),
            !_vm.lightingSystems[1].systemPower ||
            !_vm.lightingSystems[0].systemPower ||
            !_vm.customEnergyMix ||
            !_vm.lightPoints ||
            !_vm.operatingHours ||
            !_vm.electricityCost ||
            (_vm.energyMix == 0 && _vm.customEnergyMix < 0)
              ? _c("div", { staticClass: "error-overlay" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.lang.erroremptyfields) +
                      "\n\t\t\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "co2calc__savings" }, [
              _c("div", { staticClass: "co2calc__savings-section" }, [
                _c("div", { staticClass: "infographic infographic--stats" }, [
                  _c("span", { staticClass: "infographic__legend" }, [
                    _vm._v(
                      _vm._s(
                        Math.round(_vm.pathStyleEnergyConsumption.percentage)
                      ) + "% "
                    ),
                    _c("span", { staticClass: "infographic__legend-subtext" }, [
                      _vm._v(_vm._s(_vm.lang.savings))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "infographic__bg",
                      attrs: {
                        width: "100%",
                        height: "100%",
                        viewBox: "0 0 276 276",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M138 273C212.558 273 273 212.558 273 138C273 63.4416 212.558 3 138 3C63.4416 3 3 63.4416 3 138C3 212.558 63.4416 273 138 273Z",
                          stroke: "#eeeeee",
                          "stroke-width": "6",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "infographic__active",
                      attrs: {
                        width: "100%",
                        height: "100%",
                        viewBox: "0 0 276 276",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        style: _vm.pathStyleEnergyConsumption.pathStyle,
                        attrs: {
                          d:
                            "M138 273C212.558 273 273 212.558 273 138C273 63.4416 212.558 3 138 3C63.4416 3 3 63.4416 3 138C3 212.558 63.4416 273 138 273Z",
                          stroke: "#FFBC00",
                          "stroke-width": "6",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "co2calc__savings-section" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "co2calc__savings-legend" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.lang.saving) +
                        " " +
                        _vm._s(_vm.lang.energyconsumption)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "co2calc__savings-legend-main" }, [
                    _vm._v(
                      _vm._s(_vm.formatNumber(_vm.energyConsumptionDifference))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(" kWh")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "co2calc__savings-section" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "co2calc__savings-legend" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.lang.saving) +
                        " " +
                        _vm._s(_vm.lang.energycosts)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "co2calc__savings-legend-main" }, [
                    _vm._v(_vm._s(_vm.formatNumber(_vm.energyCostDifference)))
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(" CHF")])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "co2calc__savings-section" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "co2calc__savings-legend" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.lang.saving) + " CO"),
                    _c("sub", [_vm._v("2")]),
                    _vm._v("-" + _vm._s(_vm.lang.exhaust))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "co2calc__savings-legend-main" }, [
                    _vm._v(_vm._s(_vm.formatNumber(_vm.co2EmissionsDifference)))
                  ]),
                  _vm._v(" "),
                  _vm._m(3)
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "text-align": "center" } }, [
              _c("br"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button button--primary submit co2-submit",
                  class: { "button--visible": _vm.hasChanges },
                  on: { click: _vm.openRequestform }
                },
                [_vm._v(_vm._s(_vm.lang.sendresultemail))]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "co2calc__section", staticStyle: { "margin-top": "2em" } },
      [
        _c("div", { staticClass: "widget widget--timeframe" }, [
          _c("label", { attrs: { for: "timeframe" } }, [
            _c("b", [_vm._v(_vm._s(_vm.lang.timeframe))])
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.timeframe,
                expression: "timeframe",
                modifiers: { number: true }
              }
            ],
            staticClass: "range-input",
            attrs: { type: "range", id: "timeframe", min: "1", max: "20" },
            domProps: { value: _vm.timeframe },
            on: {
              __r: function($event) {
                _vm.timeframe = _vm._n($event.target.value)
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(
            "\n        " +
              _vm._s(_vm.timeframe) +
              " " +
              _vm._s(_vm.timeframe > 1 ? _vm.lang.years : _vm.lang.year) +
              "\n      "
          )
        ])
      ]
    ),
    _vm._v(" "),
    _vm.currentStep >= 2
      ? _c(
          "section",
          { staticClass: "co2calc__section co2calc__section--lightingsystem" },
          [
            _c("h2", { staticClass: "co2calc__section-title" }, [
              _vm._v(_vm._s(_vm.lang.lightingsystems))
            ]),
            _vm._v(" "),
            _vm._l(_vm.lightingSystems, function(system, index) {
              return _c(
                "div",
                { key: index, staticClass: "co2calc__lightingsystem" },
                [
                  _c("h3", { staticClass: "co2calc__section-subtitle" }, [
                    _vm._v(
                      _vm._s(
                        index == 0
                          ? _vm.lang.existingsystem
                          : _vm.lang.newsystem
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "widget widget-text" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: system.systemPower,
                          expression: "system.systemPower",
                          modifiers: { number: true }
                        }
                      ],
                      class: { error: !system.systemPower },
                      attrs: {
                        type: "number",
                        min: "0",
                        id: "system_power_" + index
                      },
                      domProps: { value: system.systemPower },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            system,
                            "systemPower",
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "system_power_" + index } }, [
                      _vm._v(_vm._s(_vm.lang.systempower))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "widget" }, [
                    _c(
                      "label",
                      {
                        staticClass: "info_icon",
                        attrs: { for: "dimming_factor_" + index }
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.lang.dimmingfactor))]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "31",
                              height: "31",
                              viewBox: "0 0 31 31",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.toggleOverlay(true)
                              }
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M15.6666 29.6667C23.5827 29.6667 29.9999 23.2494 29.9999 15.3333C29.9999 7.41725 23.5827 1 15.6666 1C7.7505 1 1.33325 7.41725 1.33325 15.3333C1.33325 23.2494 7.7505 29.6667 15.6666 29.6667Z",
                                stroke: "#555F69",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M15.6666 11.04C16.403 11.04 16.9999 10.4431 16.9999 9.70669C16.9999 8.97031 16.403 8.37335 15.6666 8.37335C14.9302 8.37335 14.3333 8.97031 14.3333 9.70669C14.3333 10.4431 14.9302 11.04 15.6666 11.04Z",
                                fill: "#555F69"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M15.6665 13.1467V22.2867",
                                stroke: "#555F69",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: system.dimmingFactor,
                            expression: "system.dimmingFactor"
                          }
                        ],
                        attrs: { id: "dimming_factor_" + index },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              system,
                              "dimmingFactor",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "1" } }, [_vm._v("1")]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0.7" } }, [
                          _vm._v("0.7")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0.55" } }, [
                          _vm._v("0.55")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0.4" } }, [
                          _vm._v("0.4")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v(_vm._s(_vm.lang.choose))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    system.dimmingFactor == 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "widget widget--timeframe widget--timeframe-dimming"
                          },
                          [
                            _c(
                              "label",
                              {
                                attrs: { for: "custom_dimming_factor_" + index }
                              },
                              [_vm._v(_vm._s(_vm.lang.choosedimmingfactor))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: system.customDimmingFactor,
                                  expression: "system.customDimmingFactor"
                                }
                              ],
                              staticClass: "range-input",
                              attrs: {
                                type: "range",
                                id: "`custom_dimming_factor_${index}`",
                                step: "0.05",
                                min: "0.05",
                                max: "1"
                              },
                              domProps: { value: system.customDimmingFactor },
                              on: {
                                __r: function($event) {
                                  return _vm.$set(
                                    system,
                                    "customDimmingFactor",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(system.customDimmingFactor) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.computeEnergyConsumption(system) > 0
                    ? _c("div", { staticClass: "subresults" }, [
                        _c("span", { staticClass: "subresults__title" }, [
                          _vm._v(_vm._s(_vm.lang.energyconsumption) + " (kWh):")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "subresults__value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(
                                _vm.computeEnergyConsumption(system)
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "subresults__title" }, [
                          _vm._v(_vm._s(_vm.lang.energycosts) + " (CHF):")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "subresults__value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(_vm.computeEnergyCost(system))
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "subresults__title" }, [
                          _vm._v("CO"),
                          _c("sub", [_vm._v("2")]),
                          _vm._v("-" + _vm._s(_vm.lang.exhaust) + " (kg CO"),
                          _c("sub", [_vm._v("2")]),
                          _vm._v("):")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "subresults__value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumber(_vm.computeCo2Emissions(system))
                            )
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.currentStep >= 1
      ? _c("section", { staticClass: "co2calc__section" }, [
          _c("h2", { staticClass: "co2calc__section-title" }, [
            _vm._v(_vm._s(_vm.lang.generalinfos))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "co2calc__general" }, [
            _c(
              "div",
              {
                staticClass: "widget widget--energymix ",
                class: { custom: _vm.energyMix == 0 }
              },
              [
                _c("label", { attrs: { for: "energy_mix" } }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.lang.energymix) + " (g CO"),
                    _c("sub", [_vm._v("2")]),
                    _vm._v("eq/kWh)")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "inline-link",
                      attrs: {
                        href:
                          "https://www.bafu.admin.ch/bafu/de/home/themen/klima/fragen-antworten.html#1369861967",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.lang.source) +
                          " www.bafu.admin.ch\n\t\t\t\t\t\t"
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.energyMix,
                        expression: "energyMix"
                      }
                    ],
                    attrs: { id: "energy_mix" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.energyMix = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "29.8", default: "" } }, [
                      _vm._v(
                        "29.8 g CO₂eq/kWh " + _vm._s(_vm.lang.productionmix)
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "54.7" } }, [
                      _vm._v("54.7 CO₂eq/kWh " + _vm._s(_vm.lang.suppliermix))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "15.7" } }, [
                      _vm._v("15.7 CO₂eq/kWh " + _vm._s(_vm.lang.renewablemix))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "128" } }, [
                      _vm._v("128 CO₂eq/kWh " + _vm._s(_vm.lang.consumermix))
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v(_vm._s(_vm.lang.choose))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "energymix-hint" }, [
                  _vm._v(
                    "Geben Sie ins untenstehende Feld den frei wählbaren Wert ein"
                  )
                ]),
                _vm._v(" "),
                _vm.energyMix == 0
                  ? _c("div", { staticClass: "widget widget-text" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.customEnergyMix,
                            expression: "customEnergyMix"
                          }
                        ],
                        class: { error: !_vm.customEnergyMix },
                        attrs: { id: "custom_energy_mix", type: "text" },
                        domProps: { value: _vm.customEnergyMix },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.customEnergyMix = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "electricity_cost" } }, [
                        _vm._v(_vm._s(_vm.lang.enterco2))
                      ])
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "widget widget-text" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.lightPoints,
                    expression: "lightPoints",
                    modifiers: { number: true }
                  }
                ],
                class: { error: !_vm.lightPoints },
                attrs: {
                  type: "number",
                  min: "0",
                  placeholder: ".",
                  id: "light_points"
                },
                domProps: { value: _vm.lightPoints },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.lightPoints = _vm._n($event.target.value)
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "light_points" } }, [
                _vm._v(_vm._s(_vm.lang.numberoflightpoints))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "widget widget-text" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.operatingHours,
                    expression: "operatingHours",
                    modifiers: { number: true }
                  }
                ],
                class: { error: !_vm.operatingHours },
                attrs: {
                  type: "number",
                  min: "0",
                  placeholder: ".",
                  id: "operating_hours"
                },
                domProps: { value: _vm.operatingHours },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.operatingHours = _vm._n($event.target.value)
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "operating_hours" } }, [
                _vm._v(_vm._s(_vm.lang.operatinghours))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "widget widget-text" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.electricityCost,
                    expression: "electricityCost",
                    modifiers: { number: true }
                  }
                ],
                class: { error: !_vm.electricityCost },
                attrs: {
                  type: "number",
                  inputmode: "decimal",
                  min: "0",
                  step: "0.1",
                  id: "electricity_cost"
                },
                domProps: { value: _vm.electricityCost },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.electricityCost = _vm._n($event.target.value)
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "electricity_cost" } }, [
                _vm._v(_vm._s(_vm.lang.energycostsperkwh))
              ])
            ])
          ]),
          _c("br"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button button--primary submit",
              on: { click: _vm.scrollToTop }
            },
            [_vm._v("\n\t\t\t" + _vm._s(_vm.lang.finish) + "\n\t\t")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showOverlay
      ? _c("div", { staticClass: "info-popup" }, [
          _c("div", { staticClass: "info-popup__inner" }, [
            _c("div", { staticClass: "info-popup__close-container" }, [
              _c(
                "button",
                {
                  staticClass: "info-popup__close",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toggleOverlay(false)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: "files/elektron/icons/cross.svg",
                      alt: "close"
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-popup__content" }, [
              _c("h2", [_vm._v(_vm._s(_vm.lang.dimmingtitletime))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.lang.dimmingsubtexttime))]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: "files/elektron/images/dimmfaktor2.gif",
                  alt: "p dimmfaktor"
                }
              }),
              _c("br"),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.lang.dimminginfo))]),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.lang.dimmingtitlemovement))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.lang.dimmingsubtextmovement))]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: "files/elektron/images/dimmfaktor.gif",
                  alt: "verkehrsabhängiger dimmfaktor"
                }
              }),
              _c("br"),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.lang.dimminginfo))])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "infographic infographic--stats" }, [
      _c("img", {
        staticClass: "infographic__icon",
        attrs: {
          src: "/files/elektron/icons/energyconsumption.gif",
          alt: "energieverbrauch icon"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "infographic" }, [
      _c("img", {
        staticClass: "infographic__icon",
        attrs: {
          src: "/files/elektron/icons/energycost.gif",
          alt: "energiekostenersparnis icon"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "infographic infographic--stats" }, [
      _c("img", {
        staticClass: "infographic__icon",
        attrs: {
          src: "/files/elektron/icons/co2saving.gif",
          alt: "co2ersparnis icon"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v(" kg CO"), _c("sub", [_vm._v("2")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }